import { render, staticRenderFns } from "./quiz-question-answer-edit.html?vue&type=template&id=b3111eca&scoped=true&"
import script from "./quiz-question-answer-edit.js?vue&type=script&lang=js&"
export * from "./quiz-question-answer-edit.js?vue&type=script&lang=js&"
import style0 from "./quiz-question-answer-edit.scss?vue&type=style&index=0&id=b3111eca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3111eca",
  null
  
)

export default component.exports